<ion-content>
  <div
    class="admin-bar flex-space-between"
    *ngIf="shouldShowSuccessBanner"
    style="display: flex; padding: 20px 40px; align-items: center; font-weight: 500; font-size: 1rem"
  >
    You've successfully subscribed – welcome aboard! 🎉
    <ion-button (click)="refreshOnSuccess()" color="success">Back to dashboard</ion-button>
  </div>
  <ion-card class="container-card" [ngClass]="{'single-plan': isCustomPrice }">
    <ion-card-header>
      <ion-card-title style="font-size: 2rem"> {{title}} </ion-card-title>
      <ion-badge
        color="danger"
        *ngIf="trialExpirationBadge"
        style="margin-top: 11px; font-size: 1rem; padding: 10px 12px"
        >{{trialExpirationBadge}}</ion-badge
      >
    </ion-card-header>
    <div *ngIf="isLoadingSubscription" style="text-align: center; padding: 40px">
      <ion-spinner name="crescent"></ion-spinner>
      <p>Checking account status...</p>
    </div>
    <div *ngIf="!isLoadingSubscription">
      <ion-grid>
        <ion-row *ngIf="!isCustomPrice">
          <ion-col size="12" size-md="4" *ngFor="let sub of subscriptions">
            <ion-card
              class="outline-card depthButton plan-card"
              (click)="selectedPlan = sub"
              [ngClass]="{ 'selected': selectedPlan === sub, 'custom': sub.isCustom }"
              [disabled]="sub.disabled"
            >
              <ion-list>
                <ion-item>
                  <ion-label>
                    <p *ngIf="sub.base">Plan</p>
                    <h3 style="font-size: 1.3rem; font-weight: 700">{{sub.name}}</h3>
                    <ion-badge color="success" *ngIf="isActive && currentPlan === sub">Subscribed</ion-badge>
                  </ion-label>
                  <ion-button class="btn-large" slot="end" *ngIf="sub.base"> Select </ion-button>
                </ion-item>
                <ion-item *ngFor="let bullet of sub.bullets">
                  <ion-icon
                    slot="start"
                    name="close"
                    style="color: red; margin-right: 10px"
                    *ngIf="bullet.disabled"
                  ></ion-icon>
                  <ion-icon
                    slot="start"
                    name="checkmark"
                    style="color: green; margin-right: 10px"
                    *ngIf="!bullet.disabled"
                  ></ion-icon>
                  <ion-label text-wrap>
                    <span style="color: #a83333" *ngIf="bullet.disabled">{{bullet.text}}</span>
                    <span style="font-weight: 500" *ngIf="!bullet.disabled">{{bullet.text}}</span>
                  </ion-label>
                </ion-item>
                <ion-item *ngIf="!sub.base">
                  <ion-button size="block" fill="outline" href="mailto:sales@unthread.io">
                    <ion-icon name="mail" class="padded-icon"></ion-icon>
                    Talk to us
                  </ion-button>
                  <ion-button size="block" fill="outline" href="https://calendly.com/tom-unthread/onboarding">
                    <ion-icon name="calendar" class="padded-icon"></ion-icon>
                    Book a meeting
                  </ion-button>
                </ion-item>
              </ion-list>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="isCustomPrice">
          <ion-col size="12">
            <ion-card class="outline-card" *ngIf="!currentPlan">
              <ion-list>
                <ion-item>
                  <ion-label>
                    <p>Plan</p>
                    <h3>Custom plan</h3>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-label>
                    <p>Status</p>
                    <h3>
                      <ion-badge color="success" *ngIf="isActive">Active</ion-badge>
                      <ion-badge *ngIf="!isActive">Trial</ion-badge>
                    </h3>
                  </ion-label>
                </ion-item>
              </ion-list>
            </ion-card>
          </ion-col>
          <ion-col size="12" *ngIf="isActive">
            <div style="padding: 8px">
              <ion-button class="btn-large" size="block" [disabled]="isLoadingCheckout" (click)="confirmPlan()">
                <span [hidden]="isLoadingCheckout">Manage my subscription</span>
                <ion-spinner name="crescent" [hidden]="!isLoadingCheckout"></ion-spinner>
              </ion-button>
              <ion-button class="btn-large" size="block" fill="clear" href="mailto:sales@unthread.io">
                <ion-icon name="mail" class="padded-icon"></ion-icon>
                Talk to us
              </ion-button>
            </div>
          </ion-col>
          <ion-col size="12" *ngIf="!isActive">
            <div style="padding: 8px">
              <ion-button
                size="block"
                (click)="openCheckout()"
                color="success"
                *ngIf="upgradePriceId && upgradeProductId"
              >
                Upgrade account
              </ion-button>
              <ion-button size="block" href="mailto:sales@unthread.io">
                <ion-icon name="mail" class="padded-icon"></ion-icon>
                Email sales
              </ion-button>
              <ion-button size="block" fill="outline" href="https://calendly.com/tom-unthread/onboarding">
                <ion-icon name="calendar" class="padded-icon"></ion-icon>
                Book a meeting
              </ion-button>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <ion-button
      *ngIf="isFailed && !isLoadingCheckout"
      fill="clear"
      class="btn-large"
      size="block"
      (click)="getSubscription()"
    >
      Something went wrong. Try again.
    </ion-button>
  </ion-card>
</ion-content>

<ion-footer *ngIf="!isCustomPrice && selectedPlan && selectedPlan.base">
  <div class="constrained-content flex-space-between">
    <ion-card class="outline-card">
      <ion-card-content>
        <div style="display: flex; justify-content: center">
          <div style="margin-right: 25px">
            <p>Base</p>
            <h3 style="font-size: 1.3rem; font-weight: 500">${{ getBasePrice() }}</h3>
          </div>
          <div style="margin-right: 25px">
            <p>&nbsp;</p>
            <h3 style="font-size: 1.3rem; font-weight: 500">+</h3>
          </div>
          <div style="margin-right: 25px">
            <p>Per channel</p>
            <h3 style="font-size: 1.3rem; font-weight: 500">$10 per 10 channels (first 10 free)</h3>
          </div>
          <div style="margin-right: 25px">
            <p>&nbsp;</p>
            <h3 style="font-size: 1.3rem; font-weight: 500">=</h3>
          </div>
          <div>
            <p>Estimated total</p>
            <h3 style="font-size: 1.3rem; font-weight: 700">{{getTotalPrice()}}/mo</h3>
          </div>
        </div>
      </ion-card-content>
    </ion-card>
    <div style="padding: 12px; display: flex; align-items: center">
      <ion-button
        class="btn-large"
        size="block"
        [disabled]="isLoadingCheckout || isLoadingSubscription"
        (click)="confirmPlan()"
      >
        <span [hidden]="isLoadingCheckout">
          {{ hasPaymentMethod ? 'Update my Subscription' : 'Add Payment Method'}}
        </span>
        <ion-spinner name="crescent" [hidden]="!isLoadingCheckout"></ion-spinner>
      </ion-button>
    </div>
  </div>
</ion-footer>
